const FILE_END_LETTERS_LENGTH = 4;
const MATCH_FILE_EXTENSION = {
    docx: 'doc',
    pptx: 'ppt',
    jpeg: 'jpg'
};
const formatBytes = (bytes) => {
    const decimals = 2;
    if (bytes === 0) {
        return '0 Bytes';
    }
    const k = 1024;
    const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / (k ** i)).toFixed(decimals))} ${sizes[i]}`;
};
const getRightLeftFileName = (name) => {
    // need this method to split file name in two parts, in order to display the name like this "Filenameisitt...ong.jpg"
    // based on container width
    const fileNameParts = name.split('.');
    const { [fileNameParts.length - 1]: fileType } = fileNameParts;
    const splitIndex = name.length - (fileType.length + FILE_END_LETTERS_LENGTH);
    const leftText = name.slice(0, splitIndex);
    const rightText = name.slice(splitIndex);
    return { leftText, rightText, fileType };
};
const getFileIcon = (fileType) => {
    const existingTypes = [
        '7z', 'cat', 'css', 'csv', 'doc', 'eps', 'exe', 'gif', 'gz', 'ics', 'img',
        'jpg', 'm4v', 'mp3', 'mp4', 'pdf', 'png', 'pps', 'ppt', 'psd', 'rar', 'swf',
        'tar', 'tgz', 'tif', 'txt', 'vcf', 'wmf', 'wmv', 'xls', 'xml', 'zip'
    ];
    const iconCode = MATCH_FILE_EXTENSION[fileType] ||
        existingTypes.find((type) => type === fileType);
    return iconCode ? `icon-24-docs-${iconCode}-mono` : 'icon-24-document-mono';
};

export { formatBytes, getFileIcon, getRightLeftFileName };
//# sourceMappingURL=helper.js.map
